import { Component, ElementRef, input, ViewChild, AfterViewInit, inject } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { DropdownInterface, DropdownOptions, Dropdown } from 'flowbite';
import { DropdownOptionColors } from '../../../shared/components/dropdown-list/dropdown-list.interface';
import { ButtonSecondaryComponent } from '../../../shared/components/button-secondary/button-secondary.component';
import { UserService } from '../../services/user.service';
import { RouterModule } from '@angular/router';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [SvgIconComponent, ButtonSecondaryComponent, RouterModule, NgClass, AsyncPipe],
  templateUrl: './header.component.html',
  styles: ``
})
export class HeaderComponent implements AfterViewInit {
  @ViewChild('dropdownTrigger') public dropdownTrigger!: ElementRef;
  @ViewChild('dropdownTarget') public dropdownTargetRef!: ElementRef;

  public icon = input<string>('images/more_24px.svg');
  public optionColors = input<DropdownOptionColors>();
  public dropdown: DropdownInterface | undefined;
  public userService = inject(UserService);

  private flowbiteOptions: DropdownOptions = {
    placement: 'left-start',
    triggerType: 'click',
    offsetSkidding: 40,
    offsetDistance: -16
  };

  ngAfterViewInit() {
    this.dropdown = new Dropdown(
      this.dropdownTargetRef.nativeElement,
      this.dropdownTrigger.nativeElement,
      this.flowbiteOptions
    );
  }

  public onSelect(): void {
    this.dropdown?.hide();
    this.userService.logout();
  }
}
